import { render, staticRenderFns } from "./FormDisplayList.vue?vue&type=template&id=2a1c0f86&"
import script from "./FormDisplayList.vue?vue&type=script&lang=js&"
export * from "./FormDisplayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports